import React from "react";
import "../../styles/PrivacyPolicy/PrivacyPolicy.css"; // Ensure you have styles for better readability

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-ouutercontainer">
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p>Effective Date: 3rd March 2025</p>

      <section>
        <h2>Introduction</h2>
        <p>
          LovenCoders operates lovencoders.com the "Website". We value your privacy and are committed to protecting any information you provide to us. This Privacy Policy outlines how we handle user information when you submit a form on our "Contact Us" page.
        </p>
      </section>

      <section>
        <h2>Information We Collect</h2>
        <p>We do not collect, store, or process any personal data except for the information voluntarily submitted by users through the contact form on our website.</p>
      </section>

      <section>
        <h2>Use of Information</h2>
        <p>The information you provide through the contact form, including startup name, startup stage, contact number, email ID, address, and self-assessment, is used solely to respond to your inquiry. We do not use this information for marketing purposes or share it with any third parties.</p>
      </section>

      <section>
        <h2>Data Storage and Security</h2>
        <p>We do not store user data on our servers beyond what is necessary to respond to your query. Once your request has been processed, the data is not retained.</p>
      </section>

      <section>
        <h2>Cookies and Tracking Technologies</h2>
        <p>We do not use cookies, analytics, tracking tools, or any other data collection mechanisms on our Website.</p>
      </section>

      <section>
        <h2>Third-Party Services</h2>
        <p>We do not integrate any third-party services that collect or process user data.</p>
      </section>

      <section>
        <h2>Your Rights</h2>
        <p>Since we do not store or process personal data beyond responding to your inquiries, there is no need for data access, modification, or deletion requests.</p>
      </section>

      <section>
        <h2>Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. Any changes will be reflected on this page, and we encourage you to review this policy periodically.</p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>If you have any questions about this Privacy Policy or how we handle your information, please contact us at:</p>
        <p><strong>LovenCoders</strong></p>
        <p><strong>Address:</strong><br />C-703, Ganesham Phase 1, Pimple Saudagar, Pune - 411027</p>
        <p><strong>Phone No:</strong><br />+91-8484000268</p>
        <p><strong>Email:</strong><br />lovencode@gmail.com</p>
      </section>
    </div>
    </div>
  );
};

export default PrivacyPolicy;
